import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login.vue'
import Nfc from './views/Nfc.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'nfc' 
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/nfc',
      name: 'nfc',
      component: Nfc
    }
  ]
})
